var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-steps',{attrs:{"active":_vm.activeStep,"align-center":"","finish-status":"success"}},_vm._l((_vm.stepList),function(item,index){return _c('el-step',{key:index,attrs:{"title":item.title}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }